import React from 'react';
import CardItem from './CardItem';
import './Cards.css';

function Cards2() {
  return (
    <div className='cards2'>
        <div className="cards__container">
            <div className="cards__wrapper">
                <ul className="cards__items">
                    <CardItem 
                    src="images/1to1.png"
                    text="Choose 1:1 home tutoring or classroom-based lessons. Personalized learning."
                    label='Personalized Learning'
                    path='/programme'
                    />
                    <CardItem 
                    src="images/presentation.png"
                    text="Students able to design and build their own projects each term, fostering creativity."
                    label='Creative Engineering'
                    path='/programme'
                    />
                    <CardItem 
                    src="images/coder-robotic.jpg"
                    text="A mix of coding, building, and development keeps classes exciting for students."
                    label='Interactive Curriculum'
                    path='/programme'
                    />
                </ul>
                <ul className="cards__items">
                    <CardItem 
                    src="images/classroom.png"
                    text="MOE-certified instructors ensure high teaching quality and effective learning experiences."
                    label='Professional, Trained Instructor'
                    path='/programme'
                    />
                    <CardItem 
                    src="images/playing.jpg"
                    text="Fun and dynamic environment, where kids learn while enjoying the process."
                    label='Engaging Lesson Plan'
                    path='/programme'
                    />
                    <CardItem 
                    src="images/coder.jpg"
                    text="Bilingual instruction available. Learn coding and robotics while practicing Mandarin."
                    label='Bilingual Learning'
                    path='/programme'
                    />
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Cards2
